import { useCouponStore } from '@st/coupon/stores/useCouponStore'
import { provideBookmakerDeps } from '@st/bookmaker/useDeps'

export default defineNuxtPlugin({
  order: 1,
  name: 'bookmakerDeps',
  dependsOn: ['i18n:plugin', 'i18n-base-init'],
  setup: () => {
    const couponStore = useCouponStore()

    provideBookmakerDeps({
      hasOutcome: couponStore.hasOutcome,
    })
  },
})
